import { config } from '../../../core/config/config';

export const updateUserReports = async (token: string, user_id: string, report_ids: string[]) => {
  try {
    const uri = `${config.uri.lp_backend}/reports/analytics/update-user`;
    const options = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ user_id, report_ids })
    };

    console.debug(`updateUserReports`, user_id, report_ids);
    const response = await fetch(uri, options);

    return response.ok;
  } catch (err) {
    throw err;
  }
};
